import React from 'react';
import { Trans } from '@lingui/react';
import BlogItem from './blogItem';
import styled from 'styled-components';
import Countries from '~/components/countries_enum.ts';

const BlogItems = ({ posts, country }) => {
    return (
        <>
            <Title>
                <Trans id={'Blog'} />
            </Title>

            <BlogItemsContainer>
                {posts.map((post, idx) => (
                    <BlogItem key={idx} post={post} country={country} />
                ))}
            </BlogItemsContainer>
        </>
    );
};

export default BlogItems;

const Title = styled.h1`
    font-style: normal;
    font-weight: bold;
    font-size: 42px;
    line-height: 49px;
    letter-spacing: 0.01em;
    margin-left: 24px;
    color: #1bad93;
    margin-top: 24px;
    text-align: center;
`;

const BlogItemsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-top: 1rem;
    padding-bottom: 8rem;

    @media (max-width: 550px) {
        justify-content: center;
    }
`;
